import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, vShow as _vShow, mergeProps as _mergeProps, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-right bg-grey-2 text-grey-7 sticky--left" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "las la-check"
}
const _hoisted_7 = { key: 1 }

import { ColumnsInterface, FilteringDisplayOptions } from '../../types/components/data-rendering'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { LanguageChoice } from 'app/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTableRow',
  props: {
    index: {},
    columns: {},
    filter: { default: null },
    checkbox: { default: undefined },
    route: { default: undefined },
    cellOptions: { default: undefined },
    showCheckbox: { type: Boolean, default: false },
    checkedValue: { type: Boolean, default: false },
    row: {}
  },
  emits: ["update:checked"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { locale } = useI18n({ useScope: 'global' })
const localeString = computed(() => locale.value as LanguageChoice)

const checked = useModelWrapper(props, emit, 'checkedValue')
const returnCellType = (key: string) => {
  return props.columns[key].type
}

const renderedText = (text: string) => {
  if (props.filter && props.filter.length > 0) {
    const re = new RegExp(props.filter, 'ig')
    if (text != undefined) {
      const results = text.replaceAll(re, '<mark>$&</mark>')
      return results
    }
  }
  return text
}

const renderTime = (duration: string): string => {
  //duration in minutes
  const hours = Math.floor(+duration / 60)
  const minutes = +duration % 60

  if (hours > 0) {
    return `${hours}h ${minutes}m`
  }
  return `${minutes}m`
}
//date should render a specific way
const renderDate = (value: Date | string | null | undefined) => {
  if (typeof value === 'undefined' || value === null || value === '') return ''
  else if (Object.prototype.toString.call(value) === '[object Date]') {
    if (!value) {
      return null
    }
    // reformat dates to MM/DD/YYYY
    return `
        ${(value as Date).getMonth() + 1}/${(value as Date).getDate()}/${(
      value as Date
    ).getFullYear()}
        `
  } else {
    return `
        ${new Date(value).getMonth() + 1}/${new Date(value).getDate()}/${new Date(
      value
    ).getFullYear()}
        `
  }
}
//values should pass as true or not
const renderBoolean = (value: string | boolean): boolean => {
  if (typeof value === 'boolean') {
    return value
  } else {
    if (value.toUpperCase() == 'T') return true
    if (value.toUpperCase() == 'TRUE') return true
    return value.toUpperCase() === 'YES' ? true : false
  }
}

const rowKeyToString = (data: any) => {
  return typeof data !== 'undefined' && data !== null ? data.toString() : ''
}

const rowClass = computed(() => {
  const out = []
  if (checked.value) {
    out.push('selected')
  }
  if (props.route?.link) {
    out.push('cursor-pointer')
  }
  return out.join(' ')
})

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (_openBlock(), _createElementBlock("tr", {
    "data-test": "table-row",
    class: _normalizeClass(rowClass.value)
  }, [
    _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.index + 1), 1),
    (_ctx.checkbox && _ctx.checkbox.checklist)
      ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
          _withDirectives(_createVNode(_component_q_checkbox, _mergeProps({
            dense: "",
            size: "xs",
            modelValue: _unref(checked),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null))
          }, _ctx.checkbox.checkProps), null, 16, ["modelValue"]), [
            [_vShow, _ctx.showCheckbox]
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `${column.label[localeString.value]}_${_ctx.row[key]}_${_ctx.row}#:${_ctx.index}`
      }, [
        (!column.hide)
          ? (_openBlock(), _createElementBlock("td", {
              key: 0,
              onClick: _withModifiers(($event: any) => (
          _ctx.cellOptions && _ctx.cellOptions.atCellClick
            ? _ctx.cellOptions.atCellClick(key, _ctx.row)
            : _ctx.route?.link
            ? _ctx.$router.push({ path: `${_ctx.route.link(_ctx.row)}` })
            : undefined
        ), ["stop"]),
              class: _normalizeClass(_ctx.cellOptions && _ctx.cellOptions.cellClass ? _ctx.cellOptions.cellClass(key) : undefined)
            }, [
              _renderSlot(_ctx.$slots, key, {
                key: `${column.label[localeString.value]}_${_ctx.row[key]}_${_ctx.row}#:${_ctx.index}`,
                rowData: _ctx.row,
                filterData: _ctx.filter
              }, () => [
                (returnCellType(key) === 'string' || returnCellType(key) === 'number')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.filter && _ctx.filter.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            innerHTML: renderedText(rowKeyToString(_ctx.row[key]).toString())
                          }, null, 8, _hoisted_4))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(rowKeyToString(_ctx.row[key]).toString()), 1)
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                (returnCellType(key) === 'time')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.filter && _ctx.filter.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass({ 'break-word': _ctx.wordWrap }),
                            innerHTML: renderedText(rowKeyToString(_ctx.row[key]).toString())
                          }, null, 10, _hoisted_5))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(renderTime(rowKeyToString(_ctx.row[key]))), 1)
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                (returnCellType(key) === 'boolean')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (renderBoolean(rowKeyToString(_ctx.row[key])))
                        ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (returnCellType(key) === 'date')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(renderDate(rowKeyToString(_ctx.row[key]))), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_3))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.$slots.itemRight)
      ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
          _renderSlot(_ctx.$slots, "itemRight", { rowData: _ctx.row })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})